import IVendorServerConfig from '../../vendor_core/core/src/server/configs/IVendorServerConfig';
import { ConfigurationTypes } from '../../vendor_core/core/src/const/ConfigurationTypes';
import GameModel from '../../vendor_core/core/src/model/GameModel';

class VendorServerConfig implements IVendorServerConfig {

    type: ConfigurationTypes = ConfigurationTypes.VENDOR_SERVER;
    _partnerId: number = parseInt(GameModel.partnerid);
    // _gameId: string = "coincrush";
    _gameId: string = "piratemulticoins";
    //_clientconfigurl: string = "https://dev-casino-client.api.relaxg.net/capi/1.0/casino/games/getclientconfig";
    _clientconfigurl: string = "https://dev-casino-client3.api.relaxg.net/capi/1.0/casino/games/getclientconfig";

    get clientconfigurl(): string {
        return this._clientconfigurl
    }
    get gameId(): string {
        return this._gameId
    }
    parseParams(data: any): void {
        if (GameModel.urlParams.gameid) {
            // We have gameid provided at url params.
            // We must use this for Relax request in order to get the dynamic rtp.
            this._gameId = GameModel.urlParams.gameid;
        }

        data?.gameid ? this._gameId = data.gameid : null;

        if (data && data.partnerid) {
            GameModel.partnerid = data.partnerid;
        }

        // Ensure we have a fallback partnerid 1.
        GameModel.partnerid = GameModel.partnerid || "1";

        data?.clientconfigurl ? this._clientconfigurl = data.clientconfigurl : null;
        if (data?.configurl) {
            data?.configurl.includes("/ios") ? this._clientconfigurl = data.configurl : this._clientconfigurl = `${data.configurl}/ios`
        }
    }

}

export default new VendorServerConfig()
